export default __webpack_public_path__ + "static/media/logo_full_hard_dark2.12536e5e.svg";